import React from "react";
import styled from "styled-components";
import constants from "./constants";

const Button = styled.button`
  ${constants.nonExportedCss};

  border: none;

  box-shadow: ${({ uiKitConfiguration }) => {
    return uiKitConfiguration.box_shadow || constants.defaults.button.boxShadow;
  }};

  font-family: ${({ uiKitConfiguration }) => {
    return uiKitConfiguration.font_family || "Arial";
  }};

  text-decoration: none;
  font-size: 1em;
  cursor: pointer;
  color: ${({ uiKitConfiguration, type }) => {
    if (type === "ghost") {
      return uiKitConfiguration.colors
        ? uiKitConfiguration.colors["color-primary-500"]
        : "black";
    }

    return "white;";
  }};

  &:hover {
    color: ${({ uiKitConfiguration, type }) => {
      if (type === "ghost") {
        return uiKitConfiguration.colors
          ? uiKitConfiguration.colors["color-primary-800"]
          : "black";
      }

      return "white;";
    }};
  }

  display: inline-block;
  padding: 10px 20px;
  border-radius: ${({ uiKitConfiguration }) =>
    uiKitConfiguration.border_radius || 0}px;

  background: ${({ uiKitConfiguration, type }) => {
    if (type === "ghost") {
      return "transparent";
    }

    if (uiKitConfiguration.aesthetic === "flat") {
      return uiKitConfiguration.colors
        ? uiKitConfiguration.colors[`color-${type}-500`]
        : "black";
    } else if (uiKitConfiguration.aesthetic === "gradient") {
      return uiKitConfiguration.colors
        ? `linear-gradient(0deg, ${uiKitConfiguration.colors[`color-${type}-800`]} 0%, ${uiKitConfiguration.colors[`color-${type}-400`]} 100%);`
        : constants.defaults.button.background;
    } else {
      return uiKitConfiguration.colors
        ? uiKitConfiguration.colors[`color-${type}-500`]
        : constants.defaults.button.background;
    }
  }};

  &:hover {
    background-color: ${({ uiKitConfiguration, type }) => {
      return uiKitConfiguration.colors
        ? uiKitConfiguration.colors[`color-${type}-600`]
        : constants.defaults.button.background;
    }};
  }
`;

export default Button;
